import Avatar from 'react-avatar';

const UserAvatar = ({name}) => {
  return <Avatar name={name} size='24' round />;
};

export default UserAvatar;
